import React, { useEffect } from 'react'
import {
  TripActivity as RecentActivityHotel,
  RecentActivityRentalCar
} from '@pcln/marketing'
import analytics from '@/shared-utils/analytics'
import {
  ANALYTICS_CATEGORY_HOME,
  ANALYTICS_CATEGORY_HOTELS
} from '@/constants/analytics'
import {
  type AbandonedSelectionExperiment,
  type AbandonedSelection
} from './types'

const TRIP_ACTIVITY_SELECTION_CLICK = 'trip activity selection click'
const TRIP_ACTIVITY_SELECTION_LOAD = 'trip activity selection load'

const getLabel = (
  abandonedSelection: AbandonedSelection | AbandonedSelectionExperiment
) => {
  if (abandonedSelection.productType === 'hotels') {
    switch (abandonedSelection.hotelDealType) {
      case 'RtlHotel':
        return 'hotel'
      case 'SopqHotel':
        return 'hotel express deal'
      case 'AbandonedPriceBreakersHotel':
        return 'hotel pricebreaker'
      case 'RETAIL':
        return 'hotel'
      case 'EXPRESS':
        return 'hotel express deal'
      case 'PRICEBREAKER':
        return 'hotel pricebreaker'
      default:
        return ''
    }
  } else if (abandonedSelection.productType === 'cars') {
    return 'car'
  }
}

export default function AbandonedSelection({
  abandonedSelection,
  analyticsCategory
}: {
  abandonedSelection: AbandonedSelection | AbandonedSelectionExperiment
  analyticsCategory:
    | typeof ANALYTICS_CATEGORY_HOME
    | typeof ANALYTICS_CATEGORY_HOTELS
}) {
  useEffect(() => {
    if (abandonedSelection) {
      analytics.fireEvent({
        category: analyticsCategory,
        action: TRIP_ACTIVITY_SELECTION_LOAD,
        label: getLabel(abandonedSelection)
      })
    }
  }, [abandonedSelection, analyticsCategory])

  if (abandonedSelection.productType === 'cars') {
    return (
      <RecentActivityRentalCar
        {...abandonedSelection}
        subheadline={
          <>
            Pick up Location: {abandonedSelection.pickupLocation}
            {abandonedSelection.isDropOffAtDifferentLocation && (
              <>
                <br />
                Drop Off Location: {abandonedSelection.returnLocation}
              </>
            )}
          </>
        }
        onClick={() => {
          analytics.fireEvent({
            category: analyticsCategory,
            action: TRIP_ACTIVITY_SELECTION_CLICK,
            label: getLabel(abandonedSelection)
          })
        }}
        altText="Trip activity image"
        ariaLabel="trip activity button"
      />
    )
  }

  return (
    <RecentActivityHotel
      {...abandonedSelection}
      onClick={() => {
        analytics.fireEvent({
          category: analyticsCategory,
          action: TRIP_ACTIVITY_SELECTION_CLICK,
          label: getLabel(abandonedSelection)
        })
      }}
      altText="Trip activity image"
      ariaLabel="trip activity button"
    />
  )
}
